import { useCallback, useEffect, useState } from 'react';
import { conversationStartersConversationStartersGet as getConversationStartersFromApi } from 'Assistant/__generated__/client';
import { ConversationStarter } from 'Assistant/__generated__/client.schemas';
import { useAuthHeader } from 'Assistant/Chatbot/hooks/useAuthHeader';
import { logException } from 'App/logging';

function useConversationStarters() {
  const [isLoadingConversationStarters, setIsLoadingConversationStarters] =
    useState(false);
  const [
    errorFetchingConversationStarters,
    setErrorFetchingConversationStarters,
  ] = useState(false);
  const [conversationStarters, setConversationStarters] = useState<
    ConversationStarter[]
  >([]);
  const accessTokenHeader = useAuthHeader();

  const getConversationStarters = useCallback(async () => {
    setIsLoadingConversationStarters(true);
    setErrorFetchingConversationStarters(false);
    try {
      const { data, status } = await getConversationStartersFromApi({
        headers: {
          'client-platform': 'web',
          ...accessTokenHeader,
        },
      });
      if (status >= 400 && status < 600) {
        throw new Error(
          `Failed to fetch conversation starters, status-code: ${status}`,
        );
      }

      setConversationStarters(data);
      setIsLoadingConversationStarters(false);
    } catch (error) {
      setIsLoadingConversationStarters(false);
      setErrorFetchingConversationStarters(true);
      logException(error);
    }
  }, [accessTokenHeader]);

  useEffect(() => {
    if (accessTokenHeader) {
      void getConversationStarters();
    }
  }, [accessTokenHeader, getConversationStarters]);

  return {
    conversationStarters,
    isLoadingConversationStarters,
    errorFetchingConversationStarters,
    refetchConversationStarters: getConversationStarters,
  };
}

export { useConversationStarters };
